import { render } from "./EditClientPayRate.vue?vue&type=template&id=11288cb9"
import script from "./EditClientPayRate.vue?vue&type=script&lang=js"
export * from "./EditClientPayRate.vue?vue&type=script&lang=js"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__